import { useDataSubjectsQuery } from "../../../../common/hooks/useSelectableItemQueries.ts";
import { deleteHttp, post } from "../../../../common/api/apiShared.ts";
import { getSystemEditQueryKey } from "../../../../system/systemEdit/SystemEdit.hooks.ts";
import { SystemModel } from "../../../../system/systemEdit/SystemEdit.types.ts";
import { useDotLegalQueryClient, useDotLegalMutation } from "../../../../common/hooks/dotLegalReactQuery.ts";

export interface UseSystemDataSubjectsProps {
    systemViewModel: SystemModel | undefined;
    systemId: string;
    isPreview: boolean;
}

export function useSystemDataSubjectsField(props: UseSystemDataSubjectsProps) {
    const systemDataSubjects = props.systemViewModel?.systemPersonalData?.systemDataSubjects ?? [];
    const processingActivityDataSubjects = props.systemViewModel?.systemPersonalData?.processingActivityDataSubjects ?? [];

    const queryClient = useDotLegalQueryClient();
    const queryKey = getSystemEditQueryKey(props.systemId);

    let { isLoading, data } = useDataSubjectsQuery(!props.isPreview);

    const addDataSubject = (dataSubjectId: string) => {
        const tempSubjects = [...systemDataSubjects];
        tempSubjects.push(dataSubjectId);
        props.systemViewModel!.systemPersonalData!.systemDataSubjects = tempSubjects;
        queryClient.setQueryData(queryKey, props.systemViewModel);
        saveMutation.mutateAsync(dataSubjectId);
    };

    const removeDataSubject = (dataSubjectId: string) => {
        const tempSubjects = systemDataSubjects.filter((x) => x !== dataSubjectId);
        props.systemViewModel!.systemPersonalData!.systemDataSubjects = tempSubjects;
        queryClient.setQueryData(queryKey, props.systemViewModel);
        deleteMutation.mutateAsync(dataSubjectId);
    };

    const saveMutation = useDotLegalMutation(save, {
        onSuccess: () => {},
    });

    function save(dataSubjectId: string) {
        return post("/system/datasubject", { systemId: props.systemId, dataSubjectId: dataSubjectId });
    }

    const deleteMutation = useDotLegalMutation(remove, {
        onSuccess: () => {},
    });

    function remove(dataSubjectId: string) {
        return deleteHttp(`/system/${props.systemId}/${dataSubjectId}/dataSubject`);
    }

    return { isLoading, data, addDataSubject, removeDataSubject, systemDataSubjects, processingActivityDataSubjects };
}
